import { render, staticRenderFns } from "./_uuid.vue?vue&type=template&id=3665e365"
import script from "./_uuid.vue?vue&type=script&lang=js"
export * from "./_uuid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports